'use client'

import * as Devtools from './devtools'

export const TanStackDevtools = Devtools.TanStackDevtools

export type {
  TanStackDevtoolsReactPlugin,
  TanStackDevtoolsReactInit,
} from './devtools'
